import { PropsWithChildren, useRef, useEffect, StyleHTMLAttributes } from 'react';
import { Type } from 'domain/constants/ribbons';
import useIntersectionObserver from 'presentation/hooks/useIntersectionObserver';
import { useRibbonAnalytics } from 'domain/selectors/ribbons';
import { createRibbonName } from 'domain/transformers/ribbons';
import { sendProductDetail, sendProductImpression, sendPromotionImpression } from 'domain/impression';
import Colorway, { Colorways } from '@uds/colorway';

interface OuterProps {
  id: string;
  name: string;
  type?: Type;
  style?: StyleHTMLAttributes<HTMLStyleElement>;
  colorway: Colorways;
  className?: string | undefined;
}

const ImpressionRibbon = (props: PropsWithChildren<OuterProps>) => {
  const { id, name, type } = props;
  const analytics = useRibbonAnalytics(id);
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (analytics == null || entry?.isIntersecting !== true) {
      return;
    }
    const list = createRibbonName(type, name);

    if (analytics.type === 'PRODUCT' && analytics.view === 'DETAIL') {
      sendProductDetail(analytics);
    } else if (analytics.type === 'PRODUCT' && analytics.view === 'IMPRESSION') {
      sendProductImpression(analytics, list);
    } else if (analytics.type === 'PROMOTION') {
      sendPromotionImpression(analytics, list);
    }
  }, [entry?.isIntersecting, analytics, name, type]);

  return (
    <Colorway
      className={props.className}
      component="section"
      colorway={props.colorway}
      style={props.style}
      ref={ref}
      id={name}
    >
      {props.children}
    </Colorway>
  );
};

ImpressionRibbon.displayName = 'ImpressionRibbon';

export default ImpressionRibbon;
